export const NestIcon = ({
  width = 400,
  height = 200,
  color = "#231F20",
}: {
  width?: number;
  height?: number;
  color?: string;
}) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <rect width={width} height={height} fill="transparent" />
      <path
        d={`M${width / 2},0 A${
          width / 2
        },${height} 0 0 1 ${width},${height} H0 A${width / 2},${height} 0 0 1 ${
          width / 2
        },0 Z`}
        fill={color}
        transform={`rotate(180, ${width / 2}, ${height / 2})`}
      />
    </svg>
  );
};
